import { render } from "./ChatNewConversationModal.vue?vue&type=template&id=4ab03487"
import script from "./ChatNewConversationModal.vue?vue&type=script&lang=js"
export * from "./ChatNewConversationModal.vue?vue&type=script&lang=js"

import exportComponent from "/deploy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__